import {React} from 'react';

function Footer(){
    return(
        <div style={{backgroundColor:'#757575',
                     color:'#fff',
                     textAlign:'center',
                     alignContent:'center',
                     margin:'auto',
                     fontSize:'0.7rem',
                     height:'4vh'}}>
            Troltech sistemas 2025 - Todos os direitos reservados
        </div>
    )
}

export default Footer;